<template>
  <div class="container customer-sign-document">

    <div v-if="!is_signed" class="row form-group opaque" style="position: relative; z-index: 10">
      <div class="col text-center">
        <h1>Firma Documento</h1>
        <VueSignaturePad class="customer-sign-document__pad" width="300px" height="300px" ref="signaturepad"
          saveType="image/png" />
      </div>
    </div>

    <div v-if="is_signed" class="row form-group opaque" style="position: relative; z-index: 10">
      <div class="col text-center">
        <h2>DOCUMENTO FIRMADO</h2>
        <h3>Puede cerrar esta pestaña</h3>
      </div>
    </div>

    <div v-else class="row form-group opaque" id="signature" style="position: relative; z-index: 10;">
      <div class="col text-center customer-sign-document__buttons">
        <button :disabled="is_loading" @click="clearSignature" class="btn btn-primary btn-wabident">
          <i class="wabident icon-wabident-trash"></i> Borrar
        </button>
        <button :disabled="is_loading" @click="saveSignature" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">
            Firmando
            <i class="fas fa-circle-notch"></i>
          </span>
          <span v-else>Firmar</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["document", "documentkey"],
  data() {
    return {
      is_loading: false,
      is_signed: false,
    };
  },
  computed: {
    ...mapGetters(["msgwindow", "errorwindow"]),
  },
  methods: {
    clearSignature() {
      this.$refs.signaturepad.clearSignature();
    },
    getInputs() {
      let ret = {};

      let input_list = document.querySelectorAll("#document_content input");
      input_list.forEach((input) => {
        let type = input.getAttribute("type");
        let id = input.getAttribute("id");

        if (type == "checkbox" || type == "radio") {
          let checked = input.checked;
          ret[id] = checked ? 1 : 0;
        } else {
          ret[id] = input.value;
        }
      });

      let text_list = document.querySelectorAll("#document_content textarea");
      text_list.forEach((input) => {
        let id = input.getAttribute("id");
        ret[id] = input.value;
      });

      return ret;
    },
    saveSignature() {
      let signature = this.$refs.signaturepad.saveSignature();
      if (!signature.isEmpty) {
        if (!this.is_loading) {
          this.is_loading = true;
          let data = {
            key: this.documentkey,
            signature: signature.data,
            inputs: this.getInputs(),
          };
          axios
            .post(`/signature`, data)
            .then((response) => {
              this.errorwindow.show("Confirmación", "Firma realizada, puede cerrar la pestaña del navegador si lo desea.", 'Ok');
              this.is_signed = true;
            })
            .catch((error) => {
              this.errorwindow.show("Error", "Error al realizar la firma. Por favor, avise a la clínica de esta incidencia", 'Ok');
              console.log("[ERR] saveSignature: ", error);
            })
            .then(() => {
              this.is_loading = false;
            });
        }
      }
    },
  },
  mounted() { },
};
</script>

<style lang="scss">
.customer-sign-document {
  .opaque {
    background: var(--theme-bg-color);
  }

  &__pad {
    margin: 30px auto;
    border: 2px var(--theme-grey-disabled) solid;
    border-radius: 2px;
  }

  &__buttons {
    button {
      margin: auto 15px;
    }

    padding-bottom: 125px;
  }

  &__sticky {
    position: fixed;
    bottom: 40px;
    width: 100%;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: row nowrap;
    z-index: 0;
  }
}
</style>
